/*
 * PhoneAuthenticator Messages
 *
 * This contains all the text for the PhoneAuthenticator scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.PhoneAuthenticator";

export default defineMessages(scope, {
  submitButton: "Receive an SMS code",
  cancel: "Cancel",
  invalidPassCode: "Incorrect code. Please try again.",
});
